// extracted by mini-css-extract-plugin
export default {"kukariContainer":"styles_kukariContainer__oGkcQ","kukari-animation":"styles_kukari-animation__iN5I4"};